export default {
  name: "pageDisplay",
  methods: {
    // If there are no results, do not display page navigation
    setDisplayPageNavigation: function () {
      if (this.resultsExist === undefined || this.resultsExist === false) {
        this.displayPageNavigation = false;
      } else if (this.pageInfo.lastPage > 1 || this.pageInfo.last_page > 1) {
        this.displayPageNavigation = true;
      } else {
        this.displayPageNavigation = false;
      }
    },
  },
};
